import { get } from '../request';
import { APP_CONFIG } from '../../config';
import { ApiEndpoints } from '../apiEndpoints.constant';
import { UpsellOfferResponse, UpsellOfferOrigin, OfferType } from '../../@types/upsellOffer';

export const getUpsellOffer = async (origin: UpsellOfferOrigin, type: OfferType): Promise<UpsellOfferResponse> => {
  const url = new URL(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.upsellOffer}`);
  url.searchParams.append('origin', origin);
  url.searchParams.append('type', type);

  return await get(url.toString(), 'XSRF-TOKEN');
};
